import app from '@/app';
import templateUrl from './constant-historic.html';

/* @ngInject */
function Controller($controller, ConstantHistoric, Plan, Principal) {
	var $ctrl = this;

  $ctrl.currentAccount = null;


  
  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
    })

    $controller('AbstractController', { $ctrl });

    this.$onInit = function() {
      ConstantHistoric.query(
        {
          idplan: $ctrl.idplan,
          version: $ctrl.version,
        },
        data => {
          $ctrl.entities = data.content;
          $ctrl.count = data.totalElements;
        }
      );
    };
}

app.component('constantHistoric', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^planHistoric'
	},
	bindings: {
		$transition$: '<',
		idplan: '<',
    version: '<'
	}
});

